import "core-js/modules/es6.array.map";
import i, { useContext as s } from "react";
import { PrimaryNavContext as r } from "./PrimaryNavContext";

var u = function u() {
  var l;

  var _s = s(r),
      n = _s.menuData;

  return i.createElement("div", {
    className: "hg-primarynav__quicklinks-menu"
  }, i.createElement("h2", {
    id: "quicklinks",
    className: "hg-primarynav__menu-header"
  }, "Quick Links"), i.createElement("ul", {
    className: "hg-primarynav__quicklinks-list",
    "aria-labelledby": "quicklinks"
  }, (l = n.quickLinks) == null ? void 0 : l.map(function (a) {
    return i.createElement("li", {
      className: "hg-primarynav__quicklinks-list-item",
      key: a.id
    }, i.createElement("a", {
      href: a.url,
      className: "hg-primarynav__quicklinks-link"
    }, a.label));
  })));
};

export { u as QuickLinksMenu };